/** PURE_IMPORTS_START ._ArrayObservable PURE_IMPORTS_END */
import { ArrayObservable } from './ArrayObservable';
export var of = ArrayObservable.of;
//# sourceMappingURL=of.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/of.js
// module id = null
// module chunks = 